import {
  GET_THEME_LIST_INFO_START,
  GET_THEME_LIST_INFO_SUCCESS,
  GET_THEME_LIST_INFO_FAIL,
  GET_THEME_LIST_INFO_MORE_START,
  GET_THEME_LIST_INFO_MORE_SUCCESS,
  GET_THEME_LIST_INFO_MORE_FAIL,
} from 'modules/types';
import { AxiosError } from 'axios';
import { IThemeListInfo } from 'scheme/main/themeListInfo';
import { GetThemeListInfoActionsType } from 'modules/actions/main/themeListInfo';

export type ThemeListInfoState = {
  loading: boolean;
  themeListInfo: IThemeListInfo[];
  error: AxiosError | null;
};

const initialState: ThemeListInfoState = {
  loading: false,
  error: null,
  themeListInfo: [
    {
      _id: '',
      category: [''],
      themeId: '',
      imageUrl: '',
      name: '',
      paymentType: '',
      price: 0,
      sale: 0,
      downloads: 0,
      priority: 0,
      recommendPriority: 0,
      requireVersion: 0,
      minimulVersion: 0,
      maximumVersion: 0,
      minimulIOSVersion: 0,
      maximumIOSVersion: 0,
      isLiveTheme: false,
      hashtag: [''],
      testcase: [],
      versionBranches: [],
      createdAt: '',
      updatedAt: '',
      isNewTheme: false,
      isBuy: false,
    },
  ],
};

export default function themeListInfoReducer(
  state: ThemeListInfoState = initialState,
  action: GetThemeListInfoActionsType,
): ThemeListInfoState {
  switch (action.type) {
    case GET_THEME_LIST_INFO_START:
      return {
        ...state,
        loading: true,
      };
    case GET_THEME_LIST_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        themeListInfo: action.themeListInfo,
      };
    case GET_THEME_LIST_INFO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_THEME_LIST_INFO_MORE_START:
      return {
        ...state,
        loading: true,
      };
    // 해당 액션 dispatch 시 themeList에 fetch해온 테마 목록을 이어 붙임
    case GET_THEME_LIST_INFO_MORE_SUCCESS:
      return {
        ...state,
        themeListInfo: state.themeListInfo.concat(action.payload),
      };
    case GET_THEME_LIST_INFO_MORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
